const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Validates that a noteId is a non-empty, valid UUID string.
 * Guards against "undefined", "null", empty strings, and other
 * non-UUID values being sent to the backend.
 */
export function isValidNoteId(noteId: string | undefined | null): noteId is string {
  if (!noteId || typeof noteId !== 'string') return false;
  return UUID_REGEX.test(noteId);
}
